const toogleSubNav = () => {
    const sectionSubNav = document.querySelector(".section-sub-nav");

    if (sectionSubNav) {
        const itemNav = sectionSubNav.querySelector(".navigation .title");
        const buttonSubNav = sectionSubNav.querySelector(".navigation .title .button-collapse");
        const dropdownList = sectionSubNav.querySelector(".dropdown-list-wrapper");

        itemNav.addEventListener("click", () => {
            dropdownList.classList.toggle("active");
            buttonSubNav.classList.toggle("button-collapse-active");
        });

        /* collapse items */
        const listItems = sectionSubNav.querySelectorAll(".dropdown-list > li");

        for (let i = 0; i < listItems.length; i++) {
            const buttonItemCollapse = listItems[i].querySelector(".button-collapse");
            const subNavItem = listItems[i].querySelector(".sub-nav-items");
            const items = listItems[i].querySelector(".item-collapse");

            if (buttonItemCollapse != null) {
                listItems[i].addEventListener("click", () => {
                    subNavItem.classList.toggle("active");
                    buttonItemCollapse.classList.toggle("button-collapse-active");
                    items.classList.toggle("active-item");

                    for (let j = 0; j < listItems.length; j++) {
                        // cierro los otros items que esten abiertos
                        const otherSubNavItem = listItems[j].querySelector(".sub-nav-items");
                        const otherButtonCollapse = listItems[j].querySelector(".button-collapse");
                        const otherItems = listItems[j].querySelector(".item-collapse");

                        if (listItems[j] !== listItems[i] && otherSubNavItem != null) {
                            otherSubNavItem.classList.remove("active");
                            otherButtonCollapse.classList.remove("button-collapse-active");
                            otherItems.classList.remove("active-item");
                        }
                    }
                });
                listItems[i].addEventListener("mouseleave", () => {
                    subNavItem.classList.remove("active");
                    buttonItemCollapse.classList.remove("button-collapse-active");
                    items.classList.remove("active-item");
                });
            }
        }
    }
};

function init() {
    toogleSubNav();
}

export default { init };
